export default (function (address, addressHousenumber, addressHousenumberAddition, postalCode, city) {
  var contactString = 'Neem contact op met je woonadviseur om je adresgegevens compleet te maken.';
  if (address && addressHousenumber && postalCode && city) {
    return "\n      ".concat(address, " ").concat(addressHousenumber, " ").concat(addressHousenumberAddition || '', "[br][/br]\n      ").concat(postalCode, " ").concat(city, "\n    ");
  }
  if (address || addressHousenumber || postalCode || addressHousenumberAddition || city) {
    return "[i]Jouw adresgegevens zijn niet volledig. ".concat(contactString, "[/i]");
  }
  return "[i]Geen adresgegevens bekend. ".concat(contactString, "[/i]");
});